import React from 'react';
import './Skills.css';
import { FaTools } from 'react-icons/fa';

function Tech() {
  const tools = [
    'Laravel',
    'Jetbrains IDEs',
    'SublimeText',
    'SublimeMerge',
    'SequelPro',
    'Ghostty',
    'Xcode',
    'Transmit',
    'BBEdit',
    'Android Studio',
    'Docker',
    'Git',
    'Kubernetes',
    'Helm'
  ];

  return (
    <div className="skills">
      <h2><FaTools className="section-icon" /> Tech I Use</h2>
      <p className="section-description">This is just some of the tech I love using day to day to bring real solutions to my end clients</p>
      <div className="skills-grid">
        {tools.map((tool, index) => (
          <div key={index} className="skill-item">
            <span className="skill-name">{tool}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tech;
